
export class MonthlyPriceResult {
    constructor(
public  car_id: string,
public monthly_price?: number,
public quote_id?: string){}
}